import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    date: 'text-xs c-grey-20',
    description: 'line-clamp-2 text-sm c-grey-20 <lg:hidden',
    title: 'line-clamp-2 text-sm fw-medium'
  }
} satisfies VfConfig['articleCard']
